import React from 'react';
import {IChangePassword} from 'types/PasswordData';
import api from 'api';
import types from '../types';
import {useDispatch, useSelector} from 'react-redux';
import {dispatchAsync} from 'redux/common';
import {ThunkDispatch} from 'redux-thunk';
import {AnyAction} from 'redux';
import ApiService from 'api/ApiService';
import useIsMountedRef from 'common/hooks/useIsMountedRef';
import {layoutTypes} from 'features/layout/redux';
import {DiplomatFeature} from 'types/DiplomatFeature';
import {licenseSelectors} from 'redux/license';
import {FormOnSubmitHelpers} from 'components/hook-form/Formik';

export const useChangePassword = (username: string, onClose: () => void) => {
   const isMountedRef = useIsMountedRef();
   const dispatch = useDispatch();
   const isFeatureSupported = useSelector(licenseSelectors.isFeatureSupported);

   const cb = React.useCallback(
      async (
         values: IChangePassword,
         {setSubmitting, setErrors}: FormOnSubmitHelpers<IChangePassword>
      ) => {
         if (!isFeatureSupported(DiplomatFeature.USER_ADMIN)) {
            await dispatch(
               dispatchAsync(api.passwordData, layoutTypes.POST_PASSWORD_DATA, {
                  getMethod: ApiService.postSecureJson,
                  data: values.passwordData,
               })
            );
         }

         await dispatch(
            dispatchAsync(api.changePassword, types.CHANGE_PASSWORD, {
               getMethod: ApiService.postSecureJson,
               data: {
                  username,
                  currentPassword: values.currentPassword,
                  newPassword: values.newPassword,
               },
               onSuccess: (res: any, dispatch?: ThunkDispatch<{}, {}, AnyAction>) => {
                  // await dispatch(action(types.LOGIN.SUCCESS, values.userName));
                  if (isMountedRef.current) {
                     setSubmitting(false);
                     onClose();
                  }
                  // if (currentLocationIsLogin()) {
                  //    history.push('/login');
                  // }
               },
               onError: (e: any) => {
                  if (isMountedRef.current) {
                     setSubmitting(false);
                     setErrors(e);
                  }
               },
            })
         );
      },
      [dispatch, isMountedRef, onClose, username, isFeatureSupported]
   );

   return [cb];
};
